export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        ".": ".",
        "...": "...",
        "2 dni": "2 days",
        "2 miesiące": "2 months",
        "2 tygodnie": "2 weeks",
        "3 dni": "3 days",
        "3 miesiące": "3 months",
        "4 dni": "4 days",
        "5 dni": "5 days",
        "6 dni": "6 days",
        "Aby skonfigurować wysyłkę, należy uzułenić wymagane pola.": "To configure sending, complete required fields.",
        "Adres": "Address",
        "Adres email": "Email address",
        "Adres email jest pusty.": "Email address is empty.",
        "Adres email odbiorcy": "Recipient email address",
        "Adres endpointu": "Endpoint address",
        "Adres URL": "URL address",
        "Adres URL został skopiowany.": "URL has been copied.",
        "Adres został skopiowany do schowka.": "Address has been copied to clipboard.",
        "AI": "AI",
        "Akcent": "Accent",
        "Akceptacja": "Approval",
        "Akceptacja dokumentów": "Document approval",
        "Akceptacja dokumentu": "Document approval",
        "Akceptacja własnych dokumentów": "Approval of own documents",
        "Akceptacja wszystkich dokumentów": "Approval of all documents",
        "Akceptowalny typ plików": "Acceptable file type",
        "Akceptowany format danych": "Acceptable data format",
        "Akceptuj": "Accept",
        "Akcje": "Actions",
        "Akordeon": "Accordion",
        "Aktualizacja definicji": "Definition update",
        "Aktualizacja dokumentu": "Document update",
        "Aktualizacja encji": "Entity update",
        "Aktualizacja wpisu": "Entry update",
        "Aktualizowane pola": "Updated fields",
        "Aktualizuj": "Update",
        "Aktywne": "Active",
        "Aktywność i widoczność w menu panelu.": "Activity and visibility in panel menu.",
        "Aktywny": "Active",
        "Aktywny webhook": "Active webhook",
        "AND — użytkownik musi mieć wszystkie zaznaczone uprawnienia. OR — wystarczy dowolne z nich. Zaznacz uprawnienia poniżej i wybierz sposób ich łączenia.": "AND — user must have all selected privileges. OR — any one is enough. Select privileges below and choose how to combine them.",
        "Ankieta": "Survey",
        "Anonimizacja": "Anonymization",
        "Anonimowy": "Anonymous",
        "Anulowany": "Canceled",
        "Anuluj": "Cancel",
        "Any sprawdza, czy istnieje pasujący rekord; Count zwraca ich liczbę; FirstOrDefault zwraca pierwszy rekord; ToList zwraca wszystkie rekordy; Sum, Min, Max i Average obliczają wartość dla wskazanego pola.": "Any checks whether a matching record exists; Count returns their number; FirstOrDefault returns first record; ToList returns all records; Sum, Min, Max, and Average calculate a value for selected field.",
        "Aplikacja": "Application",
        "Aranżacje: %0": "Layouts: %0",
        "Audio": "Audio",
        "Automatyzacja": "Automation",
        "Autouzupełnianie": "Autocomplete",
        "Baza danych": "Database",
        "Bazowy model danych": "Base data model",
        "Bezpieczeństwo": "Security",
        "Biblioteka skryptów": "Script library",
        "Bieżący dokument": "Current document",
        "Błąd": "Error",
        "Błędne": "Invalid",
        "Błędny": "Invalid",
        "Bloczek przetwarza wejście collection. Ścieżka JSON wskazuje pole elementu, np. customer.email. Znak $ oznacza cały element kolekcji.": "Block processes collection input. JSON path indicates an element field, e.g. customer.email. $ represents entire collection item.",
        "Bool": "Bool",
        "brak": "none",
        "Brak": "None",
        "Brak danych": "No data",
        "Brak definicji formularza.": "No form definition.",
        "Brak dodanych kolumn": "No columns added",
        "Brak drugiej wersji do porównania": "No second version to compare",
        "Brak komponentu": "No component",
        "Brak odpowiedzi": "No answer",
        "Brak opublikowanej definicji formularza": "No published form definition",
        "Brak pasujących elementów.": "No matching items.",
        "Brak pasujących kontrolek wśród wczytanych.": "No matching controls among loaded items.",
        "Brak różnic między wybranymi wersjami": "No differences between the selected versions",
        "Brak sekcji": "No section",
        "Brak właściwości do konfiguracji.": "No properties to configure.",
        "Brak wyboru": "No selection",
        "brak wyboru...": "no selection...",
        "Brak wykonanych operacji.": "No operations performed.",
        "Brak załączników.": "No attachments.",
        "Build": "Build",
        "Cache": "Cache",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "Cache will be stored using Redis server.",
        "Cache po stronie serwera": "Server-side cache",
        "Cache-Control": "Cache-Control",
        "Cechy": "Features",
        "Checkbox": "Checkbox",
        "Ciemny": "Dark",
        "Cyfry": "Digits",
        "Czas pomiędzy": "Time between",
        "Czas rozpoczęcia": "Start time",
        "Czas trwania": "Duration",
        "Czas zakończenia": "End time",
        "Cztery kolumny": "Four columns",
        "Czy na pewno usunąć kontrolkę?": "Are you sure you want to delete control?",
        "Czy na pewno usunąć opcję?": "Are you sure you want to delete option?",
        "Czy na pewno usunąć pytanie?": "Are you sure you want to delete question?",
        "Czy na pewno usunąć stronę formularza?": "Are you sure you want to delete form page?",
        "Czy na pewno usunąć ten warunek?": "Are you sure you want to delete this condition?",
        "Dalej": "Next",
        "Dane": "Data",
        "Dane formularza są przechowywane w obiekcie Entry.": "Form data is stored in the Entry object.",
        "Dane modułu": "Module data",
        "Dane odbiorcy": "Recipient data",
        "Dane osobowe": "Personal data",
        "Dane podglądu": "Preview data",
        "Dane skopiowane do schowka.": "Data copied to clipboard.",
        "Dane tabelaryczne": "Tabular data",
        "Dane techniczne": "Technical data",
        "Dane webhooka": "Webhook data",
        "Dane wejściowe": "Input data",
        "Dane z formularza zapisywane anonimowo": "Form data saved anonymously",
        "Dane źródła": "Source data",
        "Data": "Date",
        "Data dodania": "Date added",
        "Data i czas": "Date and time",
        "Data kalendarza": "Calendar date",
        "Data rozpoczęcia": "Start date",
        "Data rozpoczęcia publikacji": "Publication start date",
        "Data wywołania": "Call date",
        "Data zakończenia": "End date",
        "Data zakończenia publikacji": "Publication end date",
        "Data: %0 | Autor: %1 | Status: %2": "Date: %0 | Author: %1 | Status: %2",
        "Data: %0 | Status: %1": "Date: %0 | Status: %1",
        "DateTime": "DateTime",
        "Dedykowane": "Dedicated",
        "Definicja": "Definition",
        "Definicja (JSON)": "Definition (JSON)",
        "Definicja formularza znajduje się w obiekcie Form.": "Form definition is in the Form object.",
        "Definicja pól dokumentów tej sekcji.": "Definition of document fields for this section.",
        "Definicja skopiowana do schowka.": "Definition copied to clipboard.",
        "Definicje": "Definitions",
        "Definicje zostały zaktualizowane.": "Definitions have been updated.",
        "DELETE: Usunięcie wpisu": "DELETE: Entry deletion",
        "Design Studio": "Design Studio",
        "Diagram": "Diagram",
        "Diagram jest nieprawidłowy, nie zawiera żadnego wyzwalacza.": "Diagram is invalid; it contains no trigger.",
        "Diagram jest nieprawidłowy, zawiera więcej niż jeden wyzwalacz.": "Diagram is invalid; it contains more than one trigger.",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" jest elementem dwóch różnych pętli.": "Diagram is invalid. Action \"%0 (%1)\" belongs to two different loops.",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" nie posiada rodzica.": "Diagram is invalid. Action \"%0 (%1)\" has no parent.",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" nie została poprawnie skonfigurowana.": "Diagram is invalid. Action \"%0 (%1)\" is not configured correctly.",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera niezgodną liczbę początków i zakończeń pętli.": "Diagram is invalid. One of paths contains a mismatched number of loop starts and ends.",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera zagnieżdżone pętle.": "Diagram is invalid. One of paths contains nested loops.",
        "Diagram scenariusza": "Scenario diagram",
        "dla wybranego modelu danych.": "for selected data model.",
        "dla wybranego modułu dynamicznego.": "for selected dynamic module.",
        "Długość": "Length",
        "Długość czasu przechowywania": "Retention period",
        "Długość geograficzna": "Longitude",
        "do": "to",
        "Do": "To",
        "do %0": "up to %0",
        "Do akceptacji": "For approval",
        "Dodaj": "Add",
        "Dodaj dni": "Add days",
        "Dodaj dokument": "Add document",
        "Dodaj element": "Add item",
        "Dodaj endpoint": "Add endpoint",
        "Dodaj formularz": "Add form",
        "Dodaj grupę": "Add group",
        "Dodaj kategorię": "Add category",
        "Dodaj kolumnę": "Add column",
        "Dodaj komponent": "Add component",
        "Dodaj moduł": "Add module",
        "Dodaj nową wersję dokumentu": "Add new document version",
        "Dodaj obraz": "Add image",
        "Dodaj opcję": "Add option",
        "Dodaj parametr": "Add parameter",
        "Dodaj podsumowanie": "Add summary",
        "Dodaj pole": "Add field",
        "Dodaj pozycję": "Add position",
        "Dodaj punkt": "Add point",
        "Dodaj pytanie": "Add question",
        "Dodaj scenariusz": "Add scenario",
        "Dodaj sekcję": "Add section",
        "Dodaj sekcję, aby skonfigurować jej formularz i właściwości.": "Add a section to configure its form and properties.",
        "Dodaj stronę": "Add page",
        "Dodaj warunek": "Add condition",
        "Dodaj webhook": "Add webhook",
        "Dodaj webhooka": "Add webhook",
        "Dodaj wiersz": "Add row",
        "Dodaj wpis": "Add entry",
        "Dodaj wydarzenie": "Add event",
        "Dodaj wyrażenie": "Add expression",
        "Dodaj źródło": "Add source",
        "Dodaj źródło danych": "Add data source",
        "Dodaj...": "Add...",
        "Dodane": "Added",
        "Dodane przez": "Added by",
        "Dodanie endpointu": "Adding endpoint",
        "Dodanie komponentu": "Adding component",
        "Dodanie modułu": "Adding module",
        "Dodanie webhooka": "Adding webhook",
        "Dodanie źródła danych": "Adding data source",
        "Dodano za dużo plików (maksymalnie %0).": "Too many files added (maximum %0).",
        "Dodatkowe pola do wyszukiwarki": "Additional search fields",
        "Dodatkowe pola kont użytkowników": "Additional user account fields",
        "Dodawanie": "Adding",
        "Dodawanie dokumentów": "Adding documents",
        "Dodawanie i edycja własnych dokumentów": "Adding and editing own documents",
        "Dodawanie wartości dwóch kolumn": "Adding values of two columns",
        "Dokument": "Document",
        "Dokument został usunięty.": "Document has been deleted.",
        "Dokument został zduplikowany.": "Document has been duplicated.",
        "Dokumenty": "Documents",
        "Dołączanie plików": "Attaching files",
        "Domyślna wartość": "Default value",
        "Domyślnie ukryte": "Hidden by default",
        "Domyślnie widoczne": "Visible by default",
        "Domyślny": "Default",
        "Dopasuj widok": "Fit view",
        "Dopuść brak odpowiedzi": "Allow no answer",
        "Dopuszczalne typy": "Allowed types",
        "Dostęp do modułu": "Module access",
        "Dostępna jako widget": "Available as widget",
        "Dostępne endpointy REST API": "Available REST API endpoints",
        "Dostępne są właściwości obiektów, bez ich metod.": "Object properties are available, but not their methods.",
        "Dostępne zmienne": "Available variables",
        "Dostępność modułu": "Module availability",
        "Dostosuj funkcjonalności i sposób wyświetlania danych w sekcji.": "Customize functionality and how data is displayed in section.",
        "Double": "Double",
        "Dowolny": "Any",
        "Dowolny wynik (Any)": "Any result (Any)",
        "Dozwolone rozszerzenia": "Allowed extensions",
        "Dozwolone rozszerzenia plików": "Allowed file extensions",
        "Dozwolone są operację dodawania (+), usuwania (-), mnożenia (*), dzielenia (/),\r\n                                potęgowania (^2), pierwiastkowania (sqrt()). Jeżeli chcemy wyliczyć dane na podstawie\r\n                                innej kolumny musimy znać jej nazwę (zwykle jest to Numeric z liczbą na końcu np.\r\n                                Numeric2, możemy to sprawdzić klikając na daną kolumnę i odczytując nazwę z nagłówka\r\n                                zakładki konfiguracyjnej pola) oraz typ kolumny musi być ustawiony na liczbowy.": "Addition (+), subtraction (-), multiplication (*), division (/),\r\n                                exponentiation (^2), and square root (sqrt()) operations are allowed. To calculate data based on\r\n                                another column, you need to know its name (usually Numeric followed by a number, e.g.\r\n                                Numeric2; you can check this by clicking the column and reading the name in the field configuration\r\n                                tab header) and the column type must be set to numeric.",
        "Dozwolone są tylko małe i duże litery": "Only lowercase and uppercase letters are allowed",
        "Dozwolone są tylko małe litery i znak -": "Only lowercase letters and the - character are allowed",
        "Drugie imię": "Middle name",
        "Duplikuj": "Duplicate",
        "Duplikuj dokument": "Duplicate document",
        "Duplikuj punkt": "Duplicate item",
        "Duplikuj wydarzenie": "Duplicate event",
        "Duże litery": "Uppercase letters",
        "Duży": "Large",
        "Duży układ siatki": "Large grid layout",
        "Dwie kolumny": "Two columns",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "The max-age=N directive indicates that the answer remains fresh for N seconds after the answer is generated.",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "The no-store directive indicates that any cache of any kind should not store this answer.",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "Directive PRIVATE indicates that the response may only be stored in private cache (e.g., local browser cache).",
        "Dyrektywa przechowywania": "Storage directive",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "Directive PUBLIC indicates that the response may be stored in shared cache (e.g., proxy).",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "Directive s-maxage is ignored by private caches and overrides the value specified by the max-age directive for shared caches.",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "Directive s-maxage indicates how long the response remains valid in shared cache (e.g., proxy).",
        "Dyrektywy zakresu": "Range directives",
        "Dzielenie": "Division",
        "Dzielenie na paczki": "Batch processing",
        "dzień": "day",
        "Dzień": "Day",
        "Dzisiaj": "Today",
        "Edycja definicji": "Edit definition",
        "Edycja dokumentów": "Document edit",
        "Edycja dokumentu": "Document edit",
        "Edycja endpointu": "Endpoint edit",
        "Edycja komponentu": "Component edit",
        "Edycja modułu": "Module edit",
        "Edycja scenariusza": "Scenario edit",
        "Edycja w dialogu": "Edit in dialog",
        "Edycja webhooka": "Webhook edit",
        "Edycja wszystkich dokumentów": "Edit all documents",
        "Edycja źródła danych": "Data source edit",
        "Edytor": "Editor",
        "Edytor lokalizowany": "Localized editor",
        "Edytowany webhook został zmieniony.": "Edited webhook has been changed.",
        "Edytuj": "Edit",
        "Edytuj dokument": "Edit document",
        "Edytuj nazwę kontrolki": "Edit control name",
        "Edytuj punkt": "Edit point",
        "Edytuj wiersz": "Edit row",
        "Edytuj wpis": "Edit entry",
        "Edytuj wydarzenie": "Edit event",
        "Edytuj wyrażenie": "Edit expression",
        "Eksport do Excela": "Export to Excel",
        "Eksport dokumentów": "Export documents",
        "Eksportuj": "Export",
        "Element nadrzędny": "Parent item",
        "Element został usunięty": "Item has been deleted",
        "Email": "Email",
        "Endpoint został dodany.": "Endpoint has been added.",
        "Endpoint został usunięty.": "Endpoint has been deleted.",
        "Endpoint został zaktualizowany.": "Endpoint has been updated.",
        "Endpointy zostały usunięte.": "Endpoints have been deleted.",
        "Etap": "Stage",
        "Etykieta": "Label",
        "Etykiety": "Labels",
        "False": "False",
        "Filmy": "Videos",
        "Filtrowanie": "Filtering",
        "Filtrowanie listy dokumentów": "Document list filtering",
        "Filtry": "Filters",
        "Format danych": "Data format",
        "Formuła jest nieprawidłowa": "Formula is invalid",
        "Formularz": "Form",
        "Formularz bazuje na nieaktualnej wersji definicji.": "Form is based on an outdated definition version.",
        "Formularz jest wymagany": "Form is required",
        "Formularz nie jest gotowy do zapisu.": "Form is not ready to be saved.",
        "Formularz przypisany do tej sekcji nie ma dostępnej opublikowanej definicji. Sprawdź konfigurację sekcji i publikację formularza w Design Studio.": "Form assigned to this section does not have an available published definition. Check section configuration and form publication in Design Studio.",
        "Formularz został dodany.": "Form has been added.",
        "Formularz został skopiowany.": "Form has been copied.",
        "Formularz został usunięty.": "Form has been deleted.",
        "Formularz został utworzony.": "Form has been created.",
        "Formularz został wygenerowany, ale nie można go zastosować": "Form has been generated, but cannot be applied",
        "Formularz został zaakceptowany.": "Form has been approved.",
        "Formularz został zaktualizowany.": "Form has been updated.",
        "Formularze": "Forms",
        "Fragment adresu URL prowadzący do sekcji.": "URL fragment leading to section.",
        "Funkcjonalności": "Functionalities",
        "Generowanie formularza zakończone.": "Form generation completed.",
        "Generuj": "Generate",
        "Generuj formularz": "Generate form",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "GET: Entry list (sorting and pagination)",
        "GET: Pobranie danych": "GET: Data retrieval",
        "GET: Pobranie wpisu": "GET: Entry retrieval",
        "GET: Schemat (definicja formularza)": "GET: Schema (form definition)",
        "Godzina": "Time",
        "Godzina maksymalna musi mieć format HH:mm lub HH:mm:ss.": "Maximum time must be in HH:mm or HH:mm:ss format.",
        "Godzina maksymalna nie może być wcześniejsza niż minimalna.": "Maximum time cannot be earlier than minimum time.",
        "Godzina minimalna musi mieć format HH:mm lub HH:mm:ss.": "Minimum time must be in HH:mm or HH:mm:ss format.",
        "Godzina musi mieć format HH:mm lub HH:mm:ss.": "Time must be in HH:mm or HH:mm:ss format.",
        "Godzina musi odpowiadać krokowi minut: %0.": "Time must match minute interval: %0.",
        "Grafika wektorowa": "Vector graphics",
        "Grupa %0": "Group %0",
        "Grupa uprawnień %0": "Privileges group %0",
        "Grupa, w której szukamy formularzy.": "Group to search for forms in.",
        "Grupowanie": "Grouping",
        "Harmonogram": "Schedule",
        "Hasło": "Password",
        "Hierarchia": "Hierarchy",
        "Hierarchiczny": "Hierarchical",
        "Historia": "History",
        "i zwróć obiekt": "and return an object",
        "Id": "Id",
        "Id dokumentu": "Document ID",
        "Id encji": "Entity ID",
        "ID operacji": "Operation ID",
        "ID procesu": "Process ID",
        "Id wpisu": "Entry ID",
        "Identyfikator używany w adresach.": "Identifier used in URLs.",
        "Ignoruj wersjonowanie": "Ignore versioning",
        "Ikona": "Icon",
        "Ikona jest wymagana": "Icon is required",
        "Ikona modułu": "Module icon",
        "Ikona widgetu": "Widget icon",
        "Ikona widoczna obok nazwy komponentu w przyborniku.": "Icon displayed next to component name in toolbox.",
        "Ilość elementów: %0": "Number of items: %0",
        "Ilość powtórzeń pętli": "Number of loop repetitions",
        "Ilość powtórzeń po wystąpieniu błędu": "Number of retries after error occurrence",
        "Ilość wierszy": "Number of rows",
        "Ilość wyników do odrzucenia": "Number of results to discard",
        "Ilość wyników do pobrania": "Number of results to retrieve",
        "Ilość znaków": "Number of characters",
        "Ilość znaków odpowiedzi": "Number of answer characters",
        "Imię": "First name",
        "Import": "Import",
        "Import CSV": "CSV import",
        "Import dokumentów został rozpoczęty.": "Document import has started.",
        "Import modułu": "Module import",
        "Importuj": "Import",
        "Importuj definicję formularza": "Import form definition",
        "Importuj definicję scenariusza": "Import scenario definition",
        "Indeksowanie": "Indexing",
        "Info": "Info",
        "Informacja": "Information",
        "Informacje o generatorze": "Generator information",
        "input1 < input2": "input1 < input2",
        "Instrukcje": "Instructions",
        "Int": "Int",
        "Jak napisać walidację": "How to write validation",
        "Jak zbudować zapytanie": "How to build a query",
        "Jakość obrazu": "Image quality",
        "Jasny": "Light",
        "Jedna kolumna": "One column",
        "Jedno uprawnienie do dostępu obejmuje wszystkie operacje w sekcji.": "One access privilege covers all operations in section.",
        "Jeśli użyłeś zmiennych, test się nie powiedzie. Wykonaj test bez użycia zmiennych. Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "If you used variables, test will fail. Run test without using variables. Test results will always be limited to a maximum of 10 items.",
        "Język jest wymagany.": "Language is required.",
        "JSON": "JSON",
        "Kafelki": "Tiles",
        "Kalendarz": "Calendar",
        "Kanał jest wymagany": "Channel is required",
        "Kategoria": "Category",
        "Kategoria formularzy modułu.": "Module form category.",
        "Kategoria jest wymagana": "Category is required",
        "Kategoria została dodana.": "Category has been added.",
        "Kategoria została usunięta.": "Category has been deleted.",
        "Kategoria została zaktualizowana.": "Category has been updated.",
        "Kategorie": "Categories",
        "Każdy skrypt ma inną listę parametrów wejściowych.": "Each script has a different list of input parameters.",
        "Kierunek sortowania": "Sort direction",
        "Klucz": "Key",
        "Kod i walidacja": "Code and validation",
        "Kod pocztowy": "Postal code",
        "Kod walidacji": "Validation code",
        "Kod źródłowy": "Source code",
        "Kolejność i konfiguracja sekcji modułu.": "Order and configuration of module sections.",
        "Kolejność sekcji": "Section order",
        "Kolor": "Color",
        "Kolor ikony": "Icon color",
        "Kolumna": "Column",
        "Kolumny": "Columns",
        "Komponent formularza": "Form component",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "Component whose value will be used as the name of the parent item. Only components of type ``Text`` are available.",
        "Komponent relacyjny": "Relational component",
        "Komponent został dodany.": "Component has been added.",
        "Komponent został usunięty.": "Component has been deleted.",
        "Komponent został zaktualizowany.": "Component has been updated.",
        "Komponent źródłowy": "Source component",
        "Komponenty": "Components",
        "Komunikat błędu": "Error message",
        "Komunikat walidacji": "Validation message",
        "Konfiguracja": "Configuration",
        "Konfiguracja etapu": "Stage configuration",
        "Konfiguracja kolumn tabeli": "Table column configuration",
        "Konfiguracja listy": "List configuration",
        "Konfiguracja modelu": "Model configuration",
        "Konfiguracja połączenia": "Connection configuration",
        "Konfiguracja zaawansowana": "Advanced configuration",
        "Konfiguracja zapytania": "Query configuration",
        "Koniec pętli": "End loop",
        "Konstruktor": "Constructor",
        "Konta użytkowników": "User accounts",
        "Kontrolka": "Control",
        "Kontrolka dostępna publicznie": "Control available publicly",
        "Kontrolka jest obsługiwana na publicu.": "Control is supported in public interface.",
        "Kontrolka wyboru (pojedynczy wybór, value jest skrótem pobierającym pierwszy element z tablicy data)": "Selection control (single choice, value is a shortcut retrieving the first element from the data array)",
        "Kontrolka wyboru (wybór wielokrotny)": "Selection control (multiple choice)",
        "Kontrolka wysyła zapytanie HTTP do zewnętrznego serwera i zwraca status oraz treść odpowiedzi.": "Control sends an HTTP request to an external server and returns response status and body.",
        "Konwertuj obrazy do formatu WebP": "Convert images to WebP format",
        "Kopiuj": "Copy",
        "Kopiuj adres": "Copy address",
        "Kopiuj dane": "Copy data",
        "Kopiuj definicję": "Copy definition",
        "Kopiuj endpoint": "Copy endpoint",
        "Kopiuj klucz": "Copy key",
        "Kopiuj URL": "Copy URL",
        "Kraj": "Country",
        "Kreator modułu": "Module wizard",
        "Krok minut": "Minute step",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "Minute step must be a number between 1 and 60.",
        "Kroki": "Steps",
        "Kroki kreatora": "Wizard steps",
        "Krótka informacja o przeznaczeniu źródła.": "Brief information about source purpose.",
        "Krótki opis": "Short description",
        "Łączenie treści": "Content merging",
        "Liczba": "Number",
        "Liczba całkowita": "Integer",
        "Liczba dziesiętna": "Decimal number",
        "Liczba rekordów (Count)": "Number of records (Count)",
        "Liczba wyników": "Number of results",
        "Liczba zmiennoprzecinkowa": "Floating-point number",
        "Linia": "Line",
        "Lista": "List",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "Item list will be narrowed down to those related to selected values from marked components.",
        "Lista ID": "ID list",
        "Lista rekordów (ToList)": "List of records (ToList)",
        "Lista rozszerzeń oddzielona przecinkami.": "List of extensions separated by commas.",
        "Lista rozwijalna": "Dropdown list",
        "Lista sortowalna": "Sortable list",
        "Litery": "Letters",
        "Litery i cyfry": "Letters and digits",
        "Logi": "Logs",
        "Lokalizacja": "Location",
        "Lokalizowane": "Localized",
        "Long": "Long",
        "lub obiekt JSON.": "or JSON object.",
        "Maksimum": "Maximum",
        "Maksymalna ilość plików": "Maximum number of files",
        "Maksymalna rozdzielczość po optymalizacji: %0 × %1 px.": "Maximum resolution after optimization: %0 × %1 px.",
        "Maksymalny rozmiar pliku w MB": "Maximum file size in MB",
        "Maksymalny rozmiar pojedynczego pliku": "Maximum single file size",
        "Małe litery": "Lowercase letters",
        "Małe znaki": "Lowercase characters",
        "Malejąco": "Descending",
        "Mały": "Small",
        "Mały układ siatki": "Small grid layout",
        "Mapa": "Map",
        "Mapowanie": "Mapping",
        "Mapowanie danych": "Data mapping",
        "Mapowanie wartości": "Value mapping",
        "Mapowanie, filtrowanie, sortowanie i usuwanie duplikatów zwracają listę. Grupowanie zwraca obiekt grup, sumowanie liczbę, a dzielenie na paczki listę list.": "Mapping, filtering, sorting, and removing duplicates return a list. Grouping returns a group object, summing returns a number, and splitting into batches returns a list of lists.",
        "Mediana": "Median",
        "Metadane dokumentu": "Document metadata",
        "Metoda": "Method",
        "Metoda HTTP": "HTTP method",
        "Metoda HTTP wymagana przy wywołaniu webhooka.": "HTTP method required when calling webhook.",
        "Metoda żądania HTTP": "HTTP request method",
        "Miejsca po przecinku": "Decimal places",
        "Miejsca publikacji": "Publication locations",
        "Miejscowość": "Locality",
        "miesiąc": "month",
        "Miesiąc": "Month",
        "Minimalna ilość plików": "Minimum number of files",
        "Minimalna szerokość": "Minimum width",
        "Minimapa": "Minimap",
        "Minimum": "Minimum",
        "Mniejsze lub równe": "Less than or equal to",
        "Mniejsze niż": "Less than",
        "Mnożenie": "Multiplication",
        "Model danych": "Data model",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "Data model and features can only be configured when adding a new form.",
        "Model danych wynika z definicji wybranego formularza. Aby użyć innego modelu, wybierz odpowiedni formularz.": "Data model is derived from definition of selected form. To use a different model, select appropriate form.",
        "Model określa tabelę, z której zostaną pobrane dane.": "Model specifies table from which data will be retrieved.",
        "Model określony przez wybrany formularz.": "Model specified by selected form.",
        "Moduł": "Module",
        "Moduł dynamiczny": "Dynamic module",
        "Moduł i sekcja": "Module and section",
        "Moduł niedostępny": "Module unavailable",
        "Moduł został dodany.": "Module has been added.",
        "Moduł został usunięty.": "Module has been deleted.",
        "Moduł został wyeksportowany.": "Module has been exported.",
        "Moduł został zaktualizowany.": "Module has been updated.",
        "module.": "module.",
        "Moduły": "Modules",
        "Moduły dynamiczne": "Dynamic modules",
        "Modyfikacja dokumentów": "Document modification",
        "Modyfikacja dokumentu w module": "Modifying a document in a module",
        "Modyfikacja rekordu w bazie danych": "Modifying a record in database",
        "Moje dokumenty": "My documents",
        "Moje punkty": "My points",
        "Moje wydarzenia": "My events",
        "Możliwość wielokrotnego wyboru": "Multiple choice",
        "Multimedia": "Multimedia",
        "Na wejściu należy podać dane wejściowe, a następnie zadeklarować": "Input data must be provided as input, and then declare",
        "Na wyjściu zwracana jest encja wybranego modelu danych.": "The entity of selected data model is returned as output.",
        "Na wyjściu zwracany jest model wpisu wybranego formularza dynamicznego.": "The entry model of selected dynamic form is returned as output.",
        "Nadawanie uprawnień do dokumentów": "Granting privileges to documents",
        "Nadawanie uprawnień do własnych dokumentów": "Granting privileges to own documents",
        "Nadawanie uprawnień do wszystkich dokumentów": "Granting privileges to all documents",
        "Nagłówek": "Header",
        "Nagłówki": "Headers",
        "Nagłówki cache": "Cache headers",
        "Najmniejsza wartość (Min)": "Minimum value (Min)",
        "Najpierw wczytaj plik CSV.": "Load CSV file first.",
        "Największa wartość (Max)": "Maximum value (Max)",
        "Należy wybrać model danych.": "Data model must be selected.",
        "Należy wybrać przynajmniej jedną akcję.": "At least one action must be selected.",
        "Należy wybrać przynajmniej jedną właściwość modelu.": "At least one model property must be selected.",
        "Należy zapisać zmiany w scenariuszu przed uruchomieniem procesu.": "Changes to the scenario must be saved before starting the process.",
        "Narzędzia scenariusza": "Scenario tools",
        "Następny": "Next",
        "Nazwa": "Name",
        "Nazwa akcji": "Action name",
        "Nazwa etapu": "Stage name",
        "Nazwa formularza": "Form name",
        "Nazwa i ikona pomagają odnaleźć komponent w przyborniku formularza.": "Name and icon help you find the component in the form toolbox.",
        "Nazwa jest wymagana": "Name is required",
        "Nazwa kategorii": "Category name",
        "Nazwa kolumny": "Column name",
        "Nazwa kolumny z obrazem": "Name of image column",
        "Nazwa kolumny z opisem": "Column name with description",
        "Nazwa kolumny z wartością": "Column name with value",
        "Nazwa komponentu": "Component name",
        "Nazwa kontrolki": "Control name",
        "Nazwa modelu": "Model name",
        "Nazwa modułu": "Module name",
        "Nazwa modułu w panelu.": "Module name in panel.",
        "Nazwa musi mieć co najmniej 3 znaki": "Name must have at least 3 characters",
        "Nazwa musi mieć co najmniej 4 znaki": "Name must be at least 4 characters long",
        "Nazwa nie może być dłuższa niż 30 znaków": "Name cannot exceed 30 characters",
        "Nazwa nie może być dłuższy niż 50 znaków": "Name cannot exceed 50 characters",
        "Nazwa pola": "Field name",
        "Nazwa pola jest wymagana": "Field name is required",
        "Nazwa przycisku ``Dalej``": "Button name ``Next``",
        "Nazwa przycisku ``Wstecz``": "Button name ``Back``",
        "Nazwa przycisku ``Wyślij``": "Button name ``Send``",
        "Nazwa scenariusza": "Scenario name",
        "Nazwa sekcji w menu": "Menu section name",
        "Nazwa sekcji w wybranym języku.": "Section name in selected language.",
        "Nazwa sekcji widoczna w menu modułu.": "Section name displayed in module menu.",
        "Nazwa sekcji: A–Z": "Section name: A–Z",
        "Nazwa sekcji: Z–A": "Section name: Z–A",
        "Nazwa techniczna": "Technical name",
        "Nazwa ułatwiająca rozpoznanie webhooka na liście w panelu.": "Name that makes it easier to identify webhook in panel list.",
        "Nazwa uprawnienia": "Privilege name",
        "Nazwa warunku jest wymagana": "Condition name is required",
        "Nazwa warunku musi być unikalna": "Condition name must be unique",
        "Nazwa warunku musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "Condition name must start with a lowercase letter and can contain only alphanumeric characters",
        "nazwa warunku...": "condition name...",
        "Nazwa webhooka": "Webhook name",
        "Nazwa widoczna na liście źródeł danych.": "Name displayed in data source list.",
        "Nazwa wyświetlana": "Display name",
        "Nazwa wyświetlana w przyborniku formularza.": "Name displayed in form toolbox.",
        "Nazwa wyświetlana: A–Z": "Display name: A–Z",
        "Nazwa wyświetlana: Z–A": "Display name: Z–A",
        "Nazwa zdarzenia": "Event name",
        "Nazwa zmiennej jest wymagana": "Variable name is required",
        "Nazwa zmiennej musi być unikalna": "Variable name must be unique",
        "nazwa zmiennej...": "variable name...",
        "Nazwa źródła": "Source name",
        "Nazwa źródła danych": "Data source name",
        "Nazwa, identyfikator i kategoria modułu.": "Module name, identifier, and category.",
        "Nazwę zmiennej umieść między dwoma znakami": "Place variable name between two characters",
        "Nazwisko": "Last name",
        "Nazwy wartości": "Value names",
        "Nazwy właściwości modelu": "Model property names",
        "Nazwy właściwości niezmiennych": "Names of immutable properties",
        "Nie": "No",
        "Nie dotyczy plików SVG.": "Does not apply to SVG files.",
        "Nie masz uprawnień do edycji tego modułu.": "You do not have privileges to edit this module.",
        "Nie masz uprawnień do tego dokumentu": "You do not have privileges to this document",
        "Nie można tworzyć zapętlonych powiązań.": "Cannot create circular references.",
        "Nie można zapisać zmian ponieważ skrypt się nie kompiluje.": "Cannot save changes because the script does not compile.",
        "Nie podano wymaganej ilości znaków: %0.": "Required number of characters not provided: %0.",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "Required number of characters not provided: %0. (%1)",
        "Nie udało się odczytać pliku CSV.": "Failed to read CSV file.",
        "Nie udało się pobrać danych do porównania.": "Failed to fetch data for comparison.",
        "Nie udało się pobrać definicji formularzy.": "Failed to fetch form definitions.",
        "Nie udało się pobrać endpointów.": "Failed to fetch endpoints.",
        "Nie udało się pobrać kategorii.": "Failed to fetch categories.",
        "Nie udało się pobrać komponentów.": "Failed to fetch components.",
        "Nie udało się pobrać listy modułów Studio.": "Failed to fetch Studio module list.",
        "Nie udało się pobrać modułów.": "Failed to fetch modules.",
        "Nie udało się pobrać opublikowanej definicji formularza.": "Failed to fetch published form definition.",
        "Nie udało się pobrać scenariuszy.": "Failed to fetch scenarios.",
        "Nie udało się pobrać ustawień kont użytkowników": "Failed to fetch user account settings",
        "Nie udało się pobrać ustawień pól dodatkowych.": "Failed to fetch additional field settings.",
        "Nie udało się pobrać webhooka.": "Failed to fetch webhook.",
        "Nie udało się pobrać webhooków.": "Failed to fetch webhooks.",
        "Nie udało się pobrać wersji formularza.": "Failed to fetch form version.",
        "Nie udało się pobrać źródeł danych.": "Failed to fetch data sources.",
        "Nie udało się pobrać źródła danych.": "Failed to fetch data source.",
        "Nie udało się przygotować podglądu szablonu. Spróbuj ponownie.": "Failed to prepare template preview. Try again.",
        "Nie udało się skopiować adresu URL.": "Failed to copy URL.",
        "Nie udało się skopiować adresu.": "Failed to copy address.",
        "Nie udało się skopiować danych.": "Failed to copy data.",
        "Nie udało się skopiować definicji.": "Failed to copy definition.",
        "Nie udało się skopiować klucza.": "Failed to copy key.",
        "Nie udało się skopiować wyniku.": "Failed to copy result.",
        "Nie udało się uruchomić procesu.": "Failed to start process.",
        "Nie udało się usunąć {count} kategorii. Pozostały zaznaczone.": "Failed to delete {count} categories. They remain selected.",
        "Nie udało się usunąć scenariuszy: {count}.": "Failed to delete scenarios: {count}.",
        "Nie udało się wczytać definicji formularza.": "Failed to load form definition.",
        "Nie udało się wczytać definicji formularza. Spróbuj ponownie.": "Failed to load form definition. Try again.",
        "Nie udało się wczytać formularza.": "Failed to load form.",
        "Nie udało się wczytać historii scenariusza.": "Failed to load scenario history.",
        "Nie udało się wczytać komponentów.": "Failed to load components.",
        "Nie udało się wczytać kontrolki złożonej.": "Failed to load composite control.",
        "Nie udało się wczytać kontrolki złożonej. Jej zapisane źródło nie jest dostępne.": "Failed to load composite control. Its saved source is unavailable.",
        "Nie udało się wczytać listy modułów.": "Failed to load module list.",
        "Nie udało się wczytać modułu": "Failed to load module",
        "Nie udało się wczytać modułu.": "Failed to load module.",
        "Nie udało się wczytać modułu. Spróbuj ponownie.": "Failed to load module. Try again.",
        "Nie udało się wczytać operacji.": "Failed to load operations.",
        "Nie udało się wczytać powtórzeń operacji.": "Failed to load operation repetitions.",
        "Nie udało się wczytać szablonu.": "Failed to load template.",
        "Nie udało się wczytać szczegółów procesu.": "Failed to load process details.",
        "Nie udało się wygenerować formularza": "Failed to generate form",
        "Nie udało się zaimportować pliku CSV.": "Failed to import CSV file.",
        "Nie usunięto formularzy": "Forms were not deleted",
        "Nie wybrano pliku": "No file selected",
        "Nie wybrano użytkownika.": "No user selected.",
        "Nie zaleca się włączać tej opcji dla formularza z istniejącymi dokumentami.": "Enabling this option is not recommended for a form with existing documents.",
        "Nie znaleziono formularza.": "No form found.",
        "Nieaktywny": "Inactive",
        "Nienazwane uprawnienie": "Unnamed privilege",
        "Niepoprawne wyrażenie regularne": "Invalid regular expression",
        "Nieprawidłowa definicja": "Invalid definition",
        "Niestandardowe logo i stopka": "Custom logo and footer",
        "Niestandardowy błąd": "Custom error",
        "Niewidoczne": "Invisible",
        "Nieznany": "Unknown",
        "Nieznany typ": "Unknown type",
        "Nigdy": "Never",
        "Niska": "Low",
        "no-store (wyłącza cache)": "no-store (disables cache)",
        "Nowa data": "New date",
        "Nowa sekcja": "New section",
        "Nowy moduł": "New module",
        "Nowy moduł dynamiczny": "New dynamic module",
        "np. Formularz kontaktowy": "e.g. Contact form",
        "np. Powiadomienie o zamówieniu": "e.g. Order notification",
        "Numer domu": "House number",
        "Numer mieszkania": "Apartment number",
        "Obiekt JSON": "JSON object",
        "Obok siebie": "Side by side",
        "Obraz": "Image",
        "Obraz wyniku na podstawie ID z SQL.": "Result image based on ID from SQL.",
        "Obsługiwane kanały": "Supported channels",
        "Obsługiwane powiadomienia": "Supported notifications",
        "Obsługiwane są wszystkie powiadomienia.": "All notifications are supported.",
        "od": "from",
        "Od": "From",
        "od %0": "from %0",
        "Odblokuj edycję diagramu": "Unlock diagram editing",
        "Oddzielne uprawnienia do dostępu, edycji, usuwania, akceptacji i nadawania uprawnień do dokumentów.": "Separate privileges for accessing, editing, deleting, approving, and granting privileges to documents.",
        "Odejmowanie": "Subtraction",
        "odpowiada parametr": "matches parameter",
        "Odpowiedź dowolna": "Any answer",
        "Odpowiedzi": "Answers",
        "Odpowiedzi: %0 na %1": "Answers: %0 out of %1",
        "Odstęp": "Spacing",
        "Odśwież": "Refresh",
        "Omnitool": "Omnitool",
        "Opcja %0": "Option %0",
        "Opcje": "Options",
        "Opcjonalnie wskaż pole i kierunek sortowania. Ma to znaczenie zwłaszcza przy wyborze pierwszego rekordu.": "Optionally specify a field and sort direction. This is especially important when selecting the first record.",
        "Opcjonalnie wybierz pola, które mają znaleźć się w wyniku. Bez mapowania zwracany jest pełny rekord.": "Optionally select fields to include in the result. If no mapping is configured, the full record is returned.",
        "Opcjonalny warunek Dynamic LINQ. Podaj wyrażenie bez nazwy parametru lambda.": "Optional Dynamic LINQ condition. Enter the expression without a lambda parameter name.",
        "Operacja": "Operation",
        "Operacja określa format wyniku: pojedynczą wartość, pierwszy rekord albo listę rekordów.": "Operation determines the result format: a single value, the first record, or a list of records.",
        "Operacje": "Operations",
        "Operacje w pętli": "Operations in loop",
        "Operacje wykonane": "Operations performed",
        "Operator": "Operator",
        "Opis": "Description",
        "Opis błędu": "Error description",
        "Opis źródła": "Source description",
        "Opisz formularz": "Describe form",
        "Opisz, jakie pola powinny znajdować się w formularzu.": "Describe which fields should be included in the form.",
        "Optymalizacja obrazów": "Image optimization",
        "Optymalizuj rozdzielczość obrazów": "Optimize image resolution",
        "Ostatnia aktywność: {0}": "Last activity: {0}",
        "Ostatnio używane": "Recently used",
        "Ostrzeżenie": "Warning",
        "Otwórz edytor wyrażenia.": "Open expression editor.",
        "Otwórz formularz": "Open form",
        "Oznaczenie modułu w nawigacji.": "Module label in navigation.",
        "Pamięć podręczna": "Cache",
        "Panel projektu": "Project dashboard",
        "Parametry query": "Query parameters",
        "Parametry wejściowe pochodzą z innych podpiętych widgetów.": "Input parameters come from other connected widgets.",
        "Parametry wejściowe skryptu": "Script input parameters",
        "Parametry wymagane do wykonania zapytania": "Parameters required to run query",
        "Parser Liquid": "Liquid parser",
        "Pasek": "Bar",
        "Pasek postępu": "Progress bar",
        "Pełna kontrola nad właściwościami sekcji, uprawnieniami oraz endpointami API.": "Full control over section properties, privileges, and API endpoints.",
        "Pełna treść wiadomości": "Full message content",
        "Pełny": "Full",
        "Pełny dokument": "Full document",
        "Pierwiastkowanie wartości kolumny": "Column value square root",
        "Pierwsza sekcja pozostaje widoczna.": "First section remains visible.",
        "Pierwszy rekord (FirstOrDefault)": "First record (FirstOrDefault)",
        "Pierwszy wiersz jest nagłówkiem": "First row is header",
        "Pigułki": "Pills",
        "Placeholder": "Placeholder",
        "Plik": "File",
        "Plik CSV nie zawiera danych.": "CSV file contains no data.",
        "Pliki": "Files",
        "Pliki: %0": "Files: %0",
        "po elementach kolekcji": "over collection items",
        "Pobieranie dokumentów": "Retrieving documents",
        "Pobieranie dokumentu": "Retrieving document",
        "Pobieranie encji": "Retrieving entity",
        "Pobieranie i aktualizacja encji": "Retrieving and updating entity",
        "Pobieranie i usuwanie encji": "Retrieving and deleting entity",
        "Pobieranie listy encji": "Retrieving entity list",
        "Pobierz załącznik: {name}": "Download attachment: {name}",
        "Początek pętli": "Loop start",
        "Początkowa ilość wierszy": "Initial number of rows",
        "Podaj ID dokumentu lub nazwę parametru wejściowego.": "Enter document ID or input parameter name.",
        "Podaj nazwę formularza": "Enter form name",
        "Podaj nazwę scenariusza": "Enter scenario name",
        "Podaj nową nazwę": "Enter new name",
        "Podajemy go w formie jednoliniowej. Przykład:": "Enter it as a single line. Example:",
        "Podana nazwa jest zajęta.": "Provided name is taken.",
        "Podana wartość jest nieprawidłowa.": "Provided value is invalid.",
        "Podane ręcznie": "Entered manually",
        "Podanie nazwy jest wymagane.": "Providing a name is required.",
        "Podano adres": "Address provided",
        "Podano nieprawidłowe dane": "Invalid data provided",
        "Podano nieprawidłowe dane.": "Invalid data provided.",
        "Podano nieprawidłowe dane. (%0)": "Invalid data provided. (%0)",
        "Podgląd": "Preview",
        "Podgląd formularza": "Form preview",
        "Podgląd kalendarza": "Calendar preview",
        "Podgląd listy": "List preview",
        "Podgląd mapy": "Map preview",
        "Podgląd modułu": "Module preview",
        "Podgląd tabeli": "Table preview",
        "Podgląd wyniku jest niedostępny. Aby zobaczyć podgląd, scenariusz musi się wykonać poprawnie przynajmniej jeden raz.": "Result preview is unavailable. To see a preview, the scenario must run successfully at least once.",
        "Podgląd wyniku wybranego etapu": "Preview result of selected stage",
        "Podpis": "Signature",
        "Podpis modułu w wybranym języku.": "Module label in selected language.",
        "Podproces": "Subprocess",
        "Podstawowe": "Basic",
        "Podstawowe operacje na datach": "Basic date operations",
        "Podstawowe operacje na liczbach": "Basic number operations",
        "Podstawowe operacje tekstowe": "Basic text operations",
        "Podstawowe operacje warunkowe": "Basic conditional operations",
        "Podsumowanie procesu": "Process summary",
        "Pojedynczy": "Single",
        "Pojedynczy formularz": "Single form",
        "Pokaż": "Show",
        "Pokaż etykietę": "Show label",
        "Pokaż filtr w domyślnym widoku.": "Show filter in default view.",
        "Pokaż kolumnę w domyślnym widoku.": "Show column in default view.",
        "Pokaż numery stron": "Show page numbers",
        "Pokaż numery tygodnia na kalendarzu": "Show week numbers on calendar",
        "Pokaż przycisk ``Wyślij``": "Show ``Send`` button",
        "Pokaż starsze wersje": "Show older versions",
        "Pokaż tytuł formularza": "Show form title",
        "Pokaż tytuł sekcji": "Show section title",
        "Pokaż tytuł strony": "Show page title",
        "Pokaż tytuły stron": "Show page titles",
        "Pokaż więcej": "Show more",
        "Pokaż więcej komponentów": "Show more components",
        "pół roku": "half a year",
        "Pola": "Fields",
        "Pola obsługiwane przez generator dynamicznych formularzy.": "Fields supported by dynamic form generator.",
        "Pola w formularzu": "Fields in form",
        "Pola z wybranego formularza pojawią się w edytorze konta.": "Fields from selected form will appear in account editor.",
        "Pole": "Field",
        "Pole \"%0\" jest wymagane.": "Field \"%0\" is required.",
        "Pole \"%0\" jest wymagane. (%1)": "Field \"%0\" is required. (%1)",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Field \"%0\" does not contain a valid email address.",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Field \"%0\" does not contain a valid URL.",
        "Pole \"%0\" wymaga uzupełnienia wszystkich elementów": "Field \"%0\" requires all elements to be completed",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "Field \"%0\" contains a disallowed value.",
        "Pole \"%0\" zawiera nieprawidłowy symbol.": "Field \"%0\" contains an invalid symbol.",
        "Pole \"Akcje\" jest wymagane.": "\"Actions\" field is required.",
        "Pole \"Drugie imię\" jest wymagane.": "Field \"Middle name\" is required.",
        "Pole \"Id dokumentu\" jest wymagane.": "\"Document ID\" field is required.",
        "Pole \"Id encji\" jest wymagane.": "\"Entity ID\" field is required.",
        "Pole \"Imię\" jest wymagane.": "Field \"First name\" is required.",
        "Pole \"Liczba wyników\" jest wymagane.": "\"Number of results\" field is required.",
        "Pole \"Model\" jest wymagane.": "\"Model\" field is required.",
        "Pole \"Moduł dynamiczny\" jest wymagane.": "Field \"Dynamic module\" is required.",
        "Pole \"Moduł\" jest wymagane.": "\"Module\" field is required.",
        "Pole \"Nazwa modelu\" jest wymagane.": "\"Model name\" field is required.",
        "Pole \"Nazwa zdarzenia\" jest wymagane.": "\"Event name\" field is required.",
        "Pole \"Nazwisko\" jest wymagane.": "Field \"Last name\" is required.",
        "Pole \"Operacja\" jest wymagane.": "\"Operation\" field is required.",
        "Pole \"Podproces\" jest wymagane.": "\"Subprocess\" field is required.",
        "Pole \"Pole agregacji\" jest wymagane dla tej operacji.": "\"Aggregation field\" is required for this operation.",
        "Pole \"Pole\" jest wymagane.": "Field \"Field\" is required.",
        "Pole \"Sekcja modułu\" jest wymagane.": "Field \"Module section\" is required.",
        "Pole \"Sekcja\" jest wymagane.": "\"Section\" field is required.",
        "Pole \"Skrypt wykonywalny\" jest wymagane.": "\"Executable script\" field is required.",
        "Pole \"Typ agregacji\" jest wymagane.": "Field \"Aggregation type\" is required.",
        "Pole \"Tytuł\" jest wymagane.": "Field \"Title\" is required.",
        "Pole \"Wyrażenie EQL\" jest wymagane.": "\"EQL expression\" field is required.",
        "Pole agregacji": "Aggregation field",
        "Pole jest wymagane": "Field is required",
        "Pole może zawierać jedynie cyfry.": "Field can only contain digits.",
        "Pole może zawierać jedynie cyfry. (%0)": "Field can only contain digits. (%0)",
        "Pole może zawierać jedynie litery i cyfry.": "Field can only contain letters and digits.",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "Field can only contain letters and digits. (%0)",
        "Pole może zawierać jedynie litery.": "Field can only contain letters.",
        "Pole może zawierać jedynie litery. (%0)": "Field can only contain letters. (%0)",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "Field type \"%0\" is not allowed in this form.",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "Field requires at least one special character.",
        "Pole wymaga podania przynajmniej jednej cyfry.": "Field requires at least one digit.",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "Field requires at least one uppercase letter.",
        "Pole wymaga podania przynajmniej jednej małej litery.": "Field requires at least one lowercase letter.",
        "Pole wymagane": "Required field",
        "Pole zawiera": "Field contains",
        "Pomniejsz": "Zoom out",
        "Pomoc": "Help",
        "Pomoc dotycząca walidacji": "Validation help",
        "Ponów": "Retry",
        "Poprawne": "Correct",
        "Poprawny": "Valid",
        "Poprzedni": "Previous",
        "Porównaj wersje": "Compare versions",
        "Porównania": "Comparisons",
        "Porównanie": "Comparison",
        "Porównanie wersji": "Version comparison",
        "Porównywana wersja": "Compared version",
        "POST: Dowolne wyszukiwanie (Zapytanie EQL)": "POST: Any search (EQL Query)",
        "POST: Upload załączników": "POST: Upload attachments",
        "POST: Utworzenie wpisu": "POST: Create entry",
        "POST: Zapisanie zmian": "POST: Save changes",
        "Postęp formularza": "Form progress",
        "Potwierdź akceptację": "Confirm approval",
        "Potwierdź usunięcie": "Confirm deletion",
        "Potwierdź usunięcie.": "Confirm deletion.",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Powiadomienia": "Notifications",
        "Powiadomienie jest wymagane": "Notification is required",
        "Powiadomienie systemowe": "System notification",
        "Powiązana kontrolka": "Linked control",
        "Powiększ": "Enlarge",
        "Powiększenie diagramu": "Diagram zoom",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "PRIVATE directive should be added for user-personalized content, especially for responses received after login and considering privileges.",
        "Powrót": "Back",
        "Powtórzenia": "Repetitions",
        "Poziom dostępu do webhooka": "Webhook access level",
        "Poziom dostępu użytkownika": "User access level",
        "Poziom uprawnień": "Privilege level",
        "Pozostałe zaznaczenie zachowano.": "Remaining selection was preserved.",
        "pozwala na wykorzystanie zaawansowanego edytora tekstu.": "allows use of advanced text editor.",
        "Pozwól na dodawanie wierszy": "Allow adding rows",
        "Pozwól na sortowanie wierszy": "Allow sorting rows",
        "Pozycja na liście": "Position on list",
        "Pozycje zostały zapisane.": "Positions have been saved.",
        "Prezentacja": "Presentation",
        "private (tylko cache przeglądarki)": "private (browser cache only)",
        "Procent": "Percent",
        "Proces": "Process",
        "Proces został uruchomiony.": "Process has been started.",
        "Projekt": "Project",
        "Prompt": "Prompt",
        "Prompt jest wymagany.": "Prompt is required.",
        "Proste": "Simple",
        "Proste uprawnienia": "Simple privileges",
        "Prosty": "Simple",
        "Przebieg procesu na diagramie": "Process flow on diagram",
        "Przedrostek": "Prefix",
        "Przejdź do kolejnego kroku gdy:": "Proceed to the next step when:",
        "Przekroczono dozwoloną ilość znaków: %0.": "Exceeded allowed number of characters: %0.",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "Exceeded allowed number of characters: %0. (%1)",
        "Przełącznik": "Switch",
        "Przenieś filtr": "Move filter",
        "Przenieś kolumnę": "Move column",
        "Przenieś niżej": "Move down",
        "Przenieś sekcję": "Move section",
        "Przenieś wiersz": "Move row",
        "Przenieś wyżej": "Move up",
        "Przeniesienie wpisu do kosza": "Move entry to bin",
        "Przeniesione": "Moved",
        "Przeniesiono": "Moved",
        "Przerwany": "Interrupted",
        "Przesuń do góry": "Move up",
        "Przesuń na dół": "Move down",
        "Przybliżenie": "Zoom",
        "Przybornik": "Toolkit",
        "Przygotuj skrypt C#, korzystając z parametrów wejściowych pochodzących z podpiętych etapów. Aby sprawdzić poprawność kompilacji, użyj przycisku Build w zakładce Skrypt (C#). Wynik pojawi się w konsoli pod edytorem.": "Prepare a C# script using input parameters from connected stages. To check that it compiles successfully, click the Build button in the Script (C#) tab. The result will appear in the console below the editor.",
        "Przykład dla rekordów o identyfikatorze zamówienia 1:": "Example for records with order ID 1:",
        "Przykład kodu walidacji": "Validation code example",
        "Przykład mapowania z wybranymi polami:": "Mapping example with selected fields:",
        "Przykład pola z ceną brutto:": "Example of a field with gross price:",
        "Przykład walidacji": "Validation example",
        "Przykładowa struktura danych": "Sample data structure",
        "Przykłady": "Examples",
        "Przykłady konfiguracji": "Configuration examples",
        "Przypisz tablicę komunikatów do": "Assign an array of messages to",
        "przypisz wynik etapu...": "assign stage result...",
        "Przyrostek": "Suffix",
        "Przywrócenie wpisu z kosza": "Restore entry from bin",
        "public (cache przeglądarki i proxy)": "public (browser and proxy cache)",
        "Punkt został zduplikowany.": "Point has been duplicated.",
        "Puste pole używa ikony modułu.": "An empty field uses the module icon.",
        "PUT: Aktualizacja wpisu": "PUT: Update entry",
        "Pytania": "Questions",
        "Query string": "Query string",
        "Radio": "Radio",
        "Reaguj na zmiany wybranych właściwości": "Respond to changes in selected properties",
        "Ręczne uruchomienie": "Manual launch",
        "Reguła walidacji": "Validation rule",
        "Relacyjne": "Relational",
        "Renderer MJML": "MJML renderer",
        "Request body": "Request body",
        "REST API": "REST API",
        "RESTful API": "RESTful API",
        "Rezultat": "Result",
        "Rodzaj odpowiedzi": "Response type",
        "Rodzaj pętli": "Loop type",
        "Rodzaj zwracanego wyniku": "Return type",
        "rok": "year",
        "Rok": "Year",
        "Rosnąco": "Ascending",
        "Równe": "Equal",
        "Równość": "Equality",
        "Rozmiar obrazu": "Image size",
        "Rozmiar okna dialog": "Dialog window size",
        "Rozmiar paczki": "Batch size",
        "Rozmiar paczki musi być większy od zera.": "Batch size must be greater than zero.",
        "Rozmiar podawany w bajtach.": "Size provided in bytes.",
        "Rozmieść równomiernie": "Distribute evenly",
        "Różne": "Different",
        "Rozwijane": "Dropdown",
        "Satysfakcja": "Satisfaction",
        "Scenariusz aktywny": "Active scenario",
        "Scenariusz jest aktywowany po wywołaniu wybranego Webhooka.": "Scenario is activated when selected Webhook is called.",
        "Scenariusz jest aktywowany po wywołaniu wybranego zdarzenia.": "Scenario is activated when selected event is triggered.",
        "Scenariusz jest aktywowany według wybranego hamonogramu.": "Scenario is activated according to selected schedule.",
        "Scenariusz został dodany.": "Scenario has been added.",
        "Scenariusz został utworzony.": "Scenario has been created.",
        "Scenariusz został zaktualizowany.": "Scenario has been updated.",
        "Ścieżka JSON": "JSON path",
        "Ścieżka JSON jest wymagana.": "JSON path is required.",
        "Sekcja": "Section",
        "Sekcja lokalizowana": "Localized section",
        "Sekcja modułu": "Module section",
        "Sekcja powtarzalna": "Repeating section",
        "Sekcja ukryta": "Hidden section",
        "Sekcja zostanie skonfigurowana z domyślnymi właściwościami, uprawnieniami i endpointami API.": "Section will be configured with default properties, privileges, and API endpoints.",
        "Sekcje modułu": "Module sections",
        "Sekcje specyfikacji EQL": "EQL specification sections",
        "Sekcje: %0": "Sections: %0",
        "Selektor ikony": "Icon selector",
        "Selektor kolorów": "Color selector",
        "Server Side Cache": "Server Side Cache",
        "Skala 1-5": "Scale 1-5",
        "Skopiowano": "Copied",
        "Skopiowano klucz": "Key copied",
        "Skrypt (C#)": "Script (C#)",
        "Skrypt C#": "C# script",
        "Skrypt wykonywalny": "Executable script",
        "Słownik": "Dictionary",
        "Sortowanie": "Sorting",
        "Sortuj": "Sort",
        "Sparametryzowane": "Parameterized",
        "Specjalizowane": "Specialized",
        "Specyfikacja": "Specification",
        "Sposób dystrybucji": "Distribution method",
        "Sposób prezentacji dokumentów w panelu.": "How documents are displayed in panel.",
        "Sposób prezentacji zakładek": "Tab presentation method",
        "Sposób przekazania Id encji": "Entity ID passing method",
        "Sposób wyszukiwania": "Search method",
        "Sprawdza rzeczywisty typ pliku.": "Checks actual file type.",
        "Sprawdzenie czy pusty": "Check if empty",
        "Spróbuj ponownie": "Try again",
        "Średni": "Average",
        "Średnia": "Average",
        "Średnia wartość (Average)": "Average value (Average)",
        "Stała wartość": "Constant value",
        "Stan": "State",
        "Standardowe": "Standard",
        "Standardowe uprawnienia": "Standard privileges",
        "Standardowy": "Standard",
        "Start": "Start",
        "Status": "Status",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status modułu": "Module status",
        "Status publikacji": "Publication status",
        "Status webhooka": "Webhook status",
        "Status żądania": "Request status",
        "string": "string",
        "String": "String",
        "Strona": "Page",
        "Strona %0": "Page %0",
        "Strony formularza": "Form pages",
        "Studio": "Studio",
        "Stwierdzenie": "Statement",
        "Styl": "Style",
        "Sukces": "Success",
        "Suma": "Sum",
        "Suma wartości (Sum)": "Sum of values (Sum)",
        "Sumowanie": "Summing",
        "Switch": "Switch",
        "Sygnatura dokumentu": "Document signature",
        "Symbol": "Symbol",
        "Symbol endpointu": "Endpoint symbol",
        "Symbol jest wymagany": "Symbol is required",
        "Symbol jest zajęty": "Symbol is taken",
        "Symbol modułu": "Module symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "Symbol can only consist of lowercase letters, digits, and the - character",
        "Symbol musi mieć co najmniej 3 znaki": "Symbol must have at least 3 characters",
        "Symbol musi mieć co najmniej 4 znaki": "Symbol must be at least 4 characters long",
        "Symbol nie może być dłuższy niż 10 znaków": "Symbol cannot exceed 10 characters",
        "Symbol nie może być dłuższy niż 20 znaków": "Symbol cannot exceed 20 characters",
        "Symbol uprawnienia": "Privilege symbol",
        "Symbol w adresie URL": "Symbol in URL",
        "Symbol: A–Z": "Symbol: A–Z",
        "Symbol: Z–A": "Symbol: Z–A",
        "Synchronizuj": "Synchronize",
        "System": "System",
        "Szablon email": "Email template",
        "Szablon modułu": "Module template",
        "Szablon wiadomości email": "Email message template",
        "Szablon: A–Z": "Template: A–Z",
        "Szablon: Z–A": "Template: Z–A",
        "Szablony definiowane są w ": "Templates are defined in ",
        "Szczegóły": "Details",
        "Szczegóły błędu": "Error details",
        "Szczegóły endpointu": "Endpoint details",
        "Szerokość": "Width",
        "Szerokość geograficzna": "Latitude",
        "Szkic": "Draft",
        "Szukaj dokumentu...": "Search for a document...",
        "Szukaj elementu scenariusza": "Search for a scenario element",
        "Szukaj elementu…": "Search for an item…",
        "Szukaj kategorii…": "Search for a category…",
        "Szukaj kontrolki": "Search for a control",
        "Szukaj kontrolki…": "Search for a control…",
        "Ta sekcja nie ma pola tekstowego — lista pokazuje najnowsze dokumenty.": "This section has no text field — list shows latest documents.",
        "Tabela": "Table",
        "Tak": "Yes",
        "Tak/Nie": "Yes/No",
        "Tekst": "Text",
        "Tekst lokalizowany": "Localized text",
        "Tekst szybki": "Quick text",
        "Tekst zaawansowany": "Advanced text",
        "Tekst zastępczy": "Placeholder text",
        "Telefon": "Phone",
        "Ten dokument edytują również:": "This document is also being edited by:",
        "Teraz": "Now",
        "Test": "Test",
        "Testuj": "Test",
        "Testuj zapytanie": "Test query",
        "Timeout (sekundy)": "Timeout (seconds)",
        "To stały identyfikator systemowy kontrolki. Łączy ją z danymi i ustawieniami formularza, dlatego nie można go zmienić.": "This is a fixed system identifier for the control. It links it to form data and settings, so it cannot be changed.",
        "To techniczny identyfikator pola używany w danych i wyrażeniach formularza. Zmiana nazwy może wymagać aktualizacji odwołań i integracji.": "This is a technical identifier for the field used in form data and expressions. Changing its name may require updating references and integrations.",
        "Token": "Token",
        "Transformacja": "Transformation",
        "Transformacja kolekcji": "Collection transformation",
        "Treść": "Content",
        "Treść na przycisku dodawania dokumentu": "Text on the add document button",
        "Treść opcji": "Option text",
        "Treści odpowiedzi są wymagane": "Response content is required",
        "Treści pytań są wymagane": "Question content is required",
        "True": "True",
        "Trwa porównywanie wersji...": "Comparing versions...",
        "Tryb edytora formularza": "Form editor mode",
        "Tryb prezentacyjny": "Presentation mode",
        "Tryb zaawansowany": "Advanced mode",
        "Trzy kolumny": "Three columns",
        "Tworzenie dokumentów": "Document creation",
        "Tworzenie dokumentu": "Document creation",
        "Tworzenie encji": "Entity creation",
        "tydzień": "week",
        "Tydzień": "Week",
        "Tylko do odczytu": "Read only",
        "Tylko JavaScript": "JavaScript only",
        "Typ agregacji": "Aggregation type",
        "Typ autoryzacji": "Authorization type",
        "Typ kontentu": "Content type",
        "Typ odbiorcy": "Recipient type",
        "Typ pola": "Field type",
        "Typ wyniku": "Result type",
        "Typ zmiennej": "Variable type",
        "TypeScript i instrukcje import nie są obsługiwane.": "TypeScript and import statements are not supported.",
        "Typy elementów listy": "List item types",
        "Tytuł": "Title",
        "Tytuł formularza jest wymagany": "Form title is required",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "Form title cannot exceed %0 characters",
        "Tytuł sekcji": "Section title",
        "Udostępnia sekcję w aranżacjach.": "Makes section available in layouts.",
        "Układ": "Layout",
        "Ukryj": "Hide",
        "Ukryj filtr w domyślnym widoku.": "Hide filter in default view.",
        "Ukryj kolumnę w domyślnym widoku.": "Hide column in default view.",
        "Ukryta": "Hidden",
        "Ukryty": "Hidden",
        "Ukrywa moduł w menu nawigacyjnym.": "Hides module in navigation menu.",
        "Ukrywa sekcję w menu tego modułu.": "Hides section in this module's menu.",
        "Ulica": "Street",
        "Umożliwia korzystanie z modułu w panelu.": "Allows use of module in panel.",
        "Unikalna wartość": "Unique value",
        "Uprawnienia": "Privileges",
        "Uprawnienia do dokumentów": "Document privileges",
        "Uprawnienia rozróżniają operacje na własnych, wszystkich i wskazanych dokumentach.": "Privileges distinguish between operations on own, all, and specified documents.",
        "Url": "Url",
        "Uruchom proces": "Run process",
        "Uruchomienie harmonogramu": "Schedule execution",
        "Uruchomienie podprocesu": "Subprocess execution",
        "Uruchomienie procesu": "Process execution",
        "Ustaw szerokości proporcjonalnie": "Set proportional widths",
        "Ustawienia": "Settings",
        "Ustawienia formularza": "Form settings",
        "Ustawienia kolumny": "Column settings",
        "Ustawienia scenariusza": "Scenario settings",
        "Ustawienia sekcji": "Section settings",
        "Ustawienia webhooka": "Webhook settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usuń": "Delete",
        "Usuń dokument": "Delete document",
        "Usuń grupę": "Delete group",
        "Usuń kolumnę": "Delete column",
        "Usuń logi gdy wykonywanie scenariusza": "Delete logs when executing scenario",
        "Usuń opcję": "Delete option",
        "Usuń parametr": "Delete parameter",
        "Usuń pole": "Delete field",
        "Usuń pozycję": "Delete item",
        "Usuń punkt": "Delete point",
        "Usuń pytanie": "Delete question",
        "Usuń sekcję": "Delete section",
        "Usuń spacje": "Delete spaces",
        "Usuń warunek": "Delete condition",
        "Usuń wydarzenie": "Delete event",
        "Usuń z dokumentami": "Delete with documents",
        "Usunąć grupę uprawnień?": "Delete privilege group?",
        "Usunąć tę sekcję z modułu?": "Delete this section from module?",
        "Usunąć uprawnienie?": "Delete privilege?",
        "Usunięcie dokumentu": "Document removal",
        "Usunięcie formularza\n\nOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!\nCzy na pewno chcesz usunąć wybrany formularz?": "Deleting form\n\nThis operation cannot be undone. All related documents will be lost!\nAre you sure you want to delete selected form?",
        "Usunięcie wpisu": "Entry removal",
        "Usunięte": "Removed",
        "Usunięto formularze": "Forms deleted",
        "Usunięto kategorii: {count}.": "Categories deleted: {count}.",
        "Usunięto scenariusze: {count}.": "Scenarios deleted: {count}.",
        "Usuwanie dokumentów": "Document deletion",
        "Usuwanie duplikatów": "Deleting duplicates",
        "Usuwanie encji": "Deleting entity",
        "Usuwanie własnych dokumentów": "Deleting own documents",
        "Usuwanie wszystkich dokumentów": "Deleting all documents",
        "Utwórz formularz": "Create form",
        "Utwórz kopię formularza": "Create form copy",
        "Utwórz kopię z": "Create copy from",
        "Utwórz scenariusz": "Create scenario",
        "Utworzenie wpisu": "Entry creation",
        "Użycie w aranżacjach": "Use in layouts",
        "Użyj domyślnego zapytania SQL": "Use default SQL query",
        "Użytkownik": "User",
        "W przyszłości": "In the future",
        "W widgetu zmiennej możliwe jest zdefiniowanie wartości dla jednego z podstawowych typów danych, do wykorzystania w dalszej części procesu.": "Variable widget lets you define a value of one of basic data types for use later in process.",
        "w wyznaczonym zakresie": "within specified range",
        "W zapytaniu EQL można używać zmiennych, np.": "You can use variables in EQL query, e.g.",
        "W zapytaniu można używać nazw zmiennych z parametrów wejściowych skryptu, np.:": "You can use variable names from script input parameters in query, e.g.:",
        "Walidacja": "Validation",
        "Walidacja danych": "Data validation",
        "Walidacja po stronie API": "API-side validation",
        "Walidacja typów MIME": "MIME type validation",
        "Walidacja typu": "Type validation",
        "Wariant powiadomienia": "Notification variant",
        "Wartość": "Value",
        "Wartość domyślna": "Default value",
        "Wartość jest zbyt długa.": "Value is too long.",
        "Wartość lub wyrażenie": "Value or expression",
        "Wartość lub wyrażenie C#": "Value or C# expression",
        "Wartość opcji": "Option value",
        "Wartość parametru musi pasować do jego użycia w zapytaniu. Może to być": "Parameter value must match its use in query. It can be",
        "Wartość pola": "Field value",
        "Wartośc pola jest wymagana": "Field value is required",
        "Wartość warunku jest wymagana": "Condition value is required",
        "Wartość zmiennej": "Variable value",
        "Wartości zmiennych pochodzą z parametrów GET. Zmiennej": "Variable values come from GET parameters. Variable",
        "Warunek": "Condition",
        "Warunek i mapowanie": "Condition and mapping",
        "Warunek jest zdefiniowany przy użyciu wyrażenia lambda w C#. Przykład:": "Condition is defined using a lambda expression in C#. Example:",
        "Warunek łączenia uprawnień": "Privilege join condition",
        "Warunek nie zostanie spełniony": "Condition will not be met",
        "Warunek oraz mapowanie używają składni Dynamic LINQ. Przy mapowaniu możesz nadać polu nową nazwę przez as, np. Category.Name as CategoryName.": "Condition and mapping use Dynamic LINQ syntax. In mapping, you can give a field a new name using as, e.g. Category.Name as CategoryName.",
        "Warunek tylko do odczytu": "Read-only condition",
        "Warunek widoczności": "Visibility condition",
        "Warunek wymagania": "Required condition",
        "Warunek zostanie spełniony": "Condition will be met",
        "Warunki": "Conditions",
        "Warunki logiczne": "Logical conditions",
        "Warunkowo": "Conditionally",
        "Ważność": "Validity",
        "Wbudowany skrypt C#": "Built-in C# script",
        "Wczytaj opublikowaną definicję formularza.": "Load published form definition.",
        "Wczytywanie definicji formularza": "Loading form definition",
        "Wczytywanie formularza…": "Loading form…",
        "Wczytywanie komponentów": "Loading components",
        "Wczytywanie konfiguracji endpointu": "Loading endpoint configuration",
        "Wczytywanie kontrolek formularza…": "Loading form controls…",
        "Wczytywanie modelu danych": "Loading data model",
        "Wczytywanie modułów": "Loading modules",
        "Wczytywanie modułu": "Loading module",
        "Wczytywanie modułu…": "Loading module…",
        "Wczytywanie operacji": "Loading operations",
        "Wczytywanie operacji formularza": "Loading form operations",
        "Wczytywanie podglądu szablonu…": "Loading template preview…",
        "Wczytywanie pól formularza": "Loading form fields",
        "Wczytywanie powtórzeń": "Loading repetitions",
        "Wczytywanie procesu": "Loading process",
        "Wczytywanie scenariusza": "Loading scenario",
        "Wczytywanie wersji...": "Loading versions...",
        "Wczytywanie właściwości i podglądu szablonu…": "Loading properties and template preview…",
        "Webhook": "Webhook",
        "Webhook zapisano, ale nie udało się go zaakceptować.": "Webhook was saved, but could not be approved.",
        "Webhook został dodany.": "Webhook has been added.",
        "Webhook został usunięty.": "Webhook has been deleted.",
        "Webhook został zaktualizowany.": "Webhook has been updated.",
        "Webhooki": "Webhooks",
        "Wersja bazowa": "Base version",
        "Wersja formularza": "Form version",
        "Wersja porównywana": "Compared version",
        "Wersja zaakceptowana": "Version approved",
        "Wersje": "Versions",
        "Wersje i uprawnienia": "Versions and privileges",
        "Wersjonowany": "Versioned",
        "Wewnętrznie": "Internally",
        "Widget służy do budowania obiektu z wybranych wartości.": "Widget builds an object from selected values.",
        "Widget służy do parsowania szablonów w języku Liquid.": "Widget parses templates in Liquid language.",
        "Widget służy do renderowania MJML na HTML": "Widget renders MJML to HTML",
        "Widget umożliwia uruchomienie dowolnego wbudowanego skryptu C#.": "Widget lets you run any built-in C# script.",
        "Widget wybiera model z globalnej konfiguracji AI zgodnie z typem wyniku. Nie wybiera konkretnego modelu.": "Widget selects a model from global AI configuration based on result type. It does not select a specific model.",
        "Widget wyzwala scenariusz po wykonaniu akcji wybranej w polu": "Widget triggers a scenario after an action selected in field is performed",
        "Widget zwraca prawdę, gdy wejściowa wartość ma przynajmniej jeden zaznaczony typ. Dla listy możesz dodatkowo ograniczyć typ każdego jej elementu.": "Widget returns true when input value has at least one selected type. For a list, you can also restrict type of each item.",
        "Widget zwracana wybrany szablon wiadomości email.": "Widget returns selected email message template.",
        "Widoczność": "Visibility",
        "Widoczność sekcji w menu modułu": "Section visibility in module menu",
        "Widoczność w menu": "Menu visibility",
        "Widok diagramu": "Diagram view",
        "Widok kalendarza": "Calendar view",
        "Więcej...": "More...",
        "Większe lub równe": "Greater than or equal to",
        "Większe niż": "Greater than",
        "Wielkość kroku": "Step size",
        "Wielokrotny": "Multiple",
        "Wiersz": "Row",
        "Wiersz %0": "Row %0",
        "Wiersze do importu:": "Rows to import:",
        "Wklej komponent": "Paste component",
        "Włącz": "Enable",
        "Włącz konfigurację zaawansowaną, aby zdefiniować własne zapytanie EQL i przetestować jego wynik.": "Enable advanced configuration to define your own EQL query and test its result.",
        "Włącz walidację po stronie API": "Enable API-side validation",
        "Włącza przyjmowanie żądań przez webhook.": "Enables webhook to accept requests.",
        "Włączone": "Enabled",
        "Właściwości": "Properties",
        "Właściwości komponentu": "Component properties",
        "Właściwości szablonu": "Template properties",
        "Właściwości wpisu": "Entry properties",
        "Województwo": "Province",
        "Wpis został dodany.": "Entry has been added.",
        "Wpis został usunięty": "Entry has been deleted",
        "Wpis został zaakceptowany.": "Entry has been accepted.",
        "Wpis został zaktualizowany.": "Entry has been updated.",
        "Wpisz ciało funkcji walidującej dane w JavaScript.": "Enter the body of the data validation function in JavaScript.",
        "Wpisz co najmniej 4 znaki.": "Enter at least 4 characters.",
        "Wróć do diagramu": "Back to diagram",
        "Wskaż formularz, którego pola mają pojawić się w edytorze konta. Zmiana dotyczy wszystkich kont - wcześniej wprowadzone wartości pozostają zapisane.": "Select form whose fields should appear in account editor. Change applies to all accounts—previously entered values remain saved.",
        "Wskaż moduł, sekcję i metodę, aby zobaczyć adres oraz konfigurację.": "Select a module, section, and method to view the address and configuration.",
        "Wskaż pole liczbowe, na którym ma zostać obliczona wybrana operacja.": "Select a numeric field to apply the selected operation to.",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "Indicates how long the answer remains valid in Redis server memory.",
        "Wstaw kontrolkę": "Insert control",
        "Wstaw stronę": "Insert page",
        "Wstaw z dołu": "Insert from bottom",
        "Wstaw z góry": "Insert from top",
        "Wstaw z lewej strony": "Insert from left side",
        "Wstaw z prawej strony": "Insert from right side",
        "Wstecz": "Back",
        "Wszystkie": "All",
        "Wybierz": "Select",
        "Wybierz co najmniej jeden typ wartości.": "Select at least one value type.",
        "Wybierz dokumenty": "Select documents",
        "Wybierz dostępny szablon modułu.": "Select an available module template.",
        "Wybierz endpoint": "Select endpoint",
        "Wybierz formularz": "Select form",
        "Wybierz formularz, aby zobaczyć jego pola.": "Select a form to view its fields.",
        "Wybierz kategorię": "Select category",
        "Wybierz kontrolkę lub miejsce jej wstawienia.": "Select a control or where to insert it.",
        "Wybierz model docelowy, gdy zmapowany wynik ma być traktowany jako jego rekord.": "Select a target model if the mapped result should be treated as one of its records.",
        "Wybierz model, dodaj warunek tylko dla potrzebnych rekordów i dobierz operację do oczekiwanego wyniku.": "Select a model, add a condition only for the records you need, and choose an operation that matches the expected result.",
        "Wybierz moduł": "Select module",
        "Wybierz moduł z menu po lewej stronie, aby edytować jego zawartość.": "Select a module from the menu on the left to edit its content.",
        "Wybierz moduł, aby dodać sekcję – lub zostaw puste, aby utworzyć nowy moduł": "Select a module to add a section – or leave blank to create a new module",
        "wybierz moduł...": "select module...",
        "Wybierz operację, aby zobaczyć wynik i szczegóły.": "Select an operation to view the result and details.",
        "Wybierz plik CSV": "Select CSV file",
        "Wybierz sekcję": "Select section",
        "wybierz sekcję...": "select section...",
        "Wybierz typ wartości.": "Select value type.",
        "Wybierz typ wyniku.": "Select result type.",
        "wybierz...": "select...",
        "Wybierz…": "Select…",
        "Wybór": "Choice",
        "Wybór formularza": "Form selection",
        "Wybór języka": "Language selection",
        "Wybór operacji jest wymagany.": "Operation selection is required.",
        "Wybór wpływa na kolor szablonu.": "Selection affects template color.",
        "Wybór wpływa tylko na treść stopki.": "Selection only affects footer content.",
        "Wybór+": "Choice+",
        "Wybrana data jest mniejsza niż dozwolona %0.": "Selected date is less than allowed %0.",
        "Wybrana data jest większa niż dozwolona %0.": "Selected date is greater than allowed %0.",
        "Wybrana godzina jest późniejsza niż dozwolona %0.": "Selected time is later than allowed %0.",
        "Wybrana godzina jest wcześniejsza niż dozwolona %0.": "Selected time is earlier than allowed %0.",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "Selected number is less than allowed %0.",
        "Wybrana liczba jest większa niż dozwolona %0.": "Selected number is greater than allowed %0.",
        "Wybrana wersja": "Selected version",
        "Wybrane": "Selected",
        "Wybrane dokumenty": "Selected documents",
        "Wybrane: %0": "Selected: %0",
        "Wybranie przynajmniej jednego pola do aktualizacji jest wymagane.": "Select at least one field to update.",
        "Wybranie przynajmniej jednego warunku jest wymagane.": "Select at least one condition.",
        "Wybrany formularz nie zawiera pól.": "Selected form contains no fields.",
        "Wybrany użytkownik": "Selected user",
        "Wyczyść": "Clear",
        "Wyczyść wartość": "Clear value",
        "Wyczyść wybór": "Clear selection",
        "Wyczyść wyszukiwanie": "Clear search",
        "Wyczyścić uprawnienia sekcji?": "Clear section privileges?",
        "Wydarzenie zostało zduplikowane.": "Event has been duplicated.",
        "Wygląd formularza z wybranymi ustawieniami.": "Form appearance with selected settings.",
        "Wygląd modułu i formularza po konfiguracji.": "Module and form appearance after configuration.",
        "Wykonuje się": "Executing",
        "Wykryto kolumny:": "Detected columns:",
        "Wyłączone": "Disabled",
        "Wyłuskaj dane do wybranej właściwości poprzez wyrażenie w formacie języka C#. Albo zostaw pole puste, wtedy zostanie zwrócony cały wynik.": "Extract data into the selected property using an expression in C# format. Or leave the field blank to return the entire result.",
        "Wymaga autoryzacji": "Requires authorization",
        "Wymagana konfiguracja": "Configuration required",
        "Wymagane": "Required",
        "Wymagane jest wybranie formularza": "Selecting form is required",
        "Wymagane jest wybranie kategorii": "Selecting category is required",
        "Wymagane jest wybranie komponentu": "Selecting component is required",
        "Wymagane jest wybranie modułu": "Selecting module is required",
        "Wymagane jest wybranie sekcji": "Selecting section is required",
        "Wymagane jest wybranie źródła": "Selecting source is required",
        "Wymagane jest wybranie źródła danych": "Selecting data source is required",
        "Wymagane znaki": "Required characters",
        "Wymień wpis": "Replace entry",
        "Wynik etapu (JSON)": "Stage result (JSON)",
        "Wynik etapu jest wymagany": "Stage result is required",
        "Wynik operacji": "Operation result",
        "Wynik testu": "Test result",
        "Wynik transformacji": "Transformation result",
        "Wynik walidacji": "Validation result",
        "Wyrażenia warunkowe": "Conditional expressions",
        "Wyrażenie EQL": "EQL expression",
        "Wyrażenie jest prawidłowe. Udało się pobrać wartość z wyniku.": "Expression is valid. Value was successfully retrieved from the result.",
        "Wyrażenie nie jest prawidłowe. Nie udało się pobrać wartości z wyniku.": "Expression is invalid. Could not retrieve value from the result.",
        "Wyrażenie regularne": "Regular expression",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "Expression in form \"/pattern/flag\" is not supported, use pattern value only",
        "Wysłanie emaila": "Sending email",
        "Wysłanie powiadomień": "Sending notifications",
        "Wyślij": "Send",
        "Wyślij powiadomienie gdy wykonywanie scenariusza": "Send notification when scenario is running",
        "Wysoka": "High",
        "Wystąpił błąd podczas otwierania modułu. Możesz spróbować ponownie lub wrócić do listy modułów.": "An error occurred while opening the module. You can try again or go back to the module list.",
        "Wystąpił błąd podczas próby importu definicji modułu.": "Error occurred during module definition import attempt.",
        "Wystąpił nieokreślony problem.": "An unspecified problem occurred.",
        "Wyświetlanie dokumentów": "Document display",
        "Wyszukaj encję…": "Search for an entity…",
        "Wyszukiwany ciąg znaków": "Search string",
        "Wytnij": "Cut",
        "Wywołanie powiadomienia": "Notification call",
        "Wywołanie webhooka": "Webhook call",
        "Wywołanie zdarzenia": "Event call",
        "Wyzwalacze": "Triggers",
        "Wzorzec": "Pattern",
        "Z uprawnieniami do modułu": "With module privileges",
        "Zaakceptowany": "Accepted",
        "Zaawansowane": "Advanced",
        "Zaawansowane uprawnienia": "Advanced privileges",
        "Zaawansowany edytor tekstu": "Advanced text editor",
        "Zablokuj edycję diagramu": "Lock diagram editing",
        "Zachowaj oryginalny format obrazów": "Preserve original image format",
        "zacznij pisać aby wyszukać szablon...": "start typing to search for a template...",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search user...",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "Start typing Form or Entry to trigger suggestions.",
        "Zaczyna sie od": "Starts with",
        "Zagrożenie": "Threat",
        "Zaimportowano definicję modułu.": "Module definition has been imported.",
        "Zakładki": "Bookmarks",
        "Zakończ edycje": "Finish edit",
        "Zakończony": "Finished",
        "zakończy się porażką": "will end in failure",
        "zakończy się sukcesem": "will end successfully",
        "Zakres": "Range",
        "Zakres czasu": "Time range",
        "Zakres funkcjonalności": "Scope of functionality",
        "Zakres uprawnienia": "Privilege scope",
        "Zaktualizuj formularz": "Update form",
        "Zaktualizuj najnowszą wersję dokumentu": "Update latest document version",
        "Załączniki": "Attachments",
        "Zależna od kontrolki": "Dependent on control",
        "Zamień wersje": "Swap versions",
        "Zamknij": "Close",
        "Zaokrąglenie": "Rounding",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz i zamknij": "Save and close",
        "Zapisz jako": "Save as",
        "Zapisz kategorię": "Save category",
        "Zapisz pozycje": "Save positions",
        "Zapisz zmiany": "Save changes",
        "Zapytania i mapowanie kolumn": "Queries and column mapping",
        "Zapytanie": "Query",
        "Zapytanie do bazy danych": "Database query",
        "Zapytanie HTTP": "HTTP request",
        "Zapytanie SQL do pobrania po ID": "SQL query to fetch by ID",
        "Zapytanie SQL do wyszukiwania": "SQL query for search",
        "Zasięg": "Range",
        "Zawiera": "Contains",
        "Zawiera nagłówki": "Contains headers",
        "Zawiera parametry query": "Contains query parameters",
        "Zawiera treść": "Contains content",
        "Zawsze": "Always",
        "Zdecyduj czy scenariusz ma obsługiwać wczystkie czy tylko wybrane powiadomienia.": "Decide whether the scenario should handle all or only selected notifications.",
        "Zdecyduj czy scenariusz ma obsługiwać wszystkie czy tylko wybrane kanały.": "Decide whether the scenario should handle all or only selected channels.",
        "Zdefiniuj wygląd komponentu oraz opcjonalne reguły sprawdzania danych po stronie API.": "Define component appearance and optional API-side data validation rules.",
        "Zdjęcia": "Photos",
        "Zdjęcie": "Photo",
        "Zestaw uprawnień": "Privilege set",
        "Zgoda": "Consent",
        "Zliczanie": "Counting",
        "Zmiana statusu jest teraz niedostępna.": "Status change is now unavailable.",
        "Zmiany": "Changes",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmienione": "Changed",
        "Zmienna": "Variable",
        "Zmienna musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "Variable must start with lowercase letter and can contain only alphanumeric characters",
        "Zmienne w zapytaniu EQL": "Variables in EQL query",
        "Zmniejsz": "Reduce",
        "Znaczenie operacji": "Operation meaning",
        "Znaki specialne": "Special characters",
        "Zoom": "Zoom",
        "Zostaną zaktualizowane definicje wszystkich dokumentów.": "Definitions of all documents will be updated.",
        "Źródła danych": "Data sources",
        "Źródło danych": "Data source",
        "Żródło danych": "Data source",
        "Źródło danych zostało dodane.": "Data source has been added.",
        "Źródło danych zostało zaktualizowane.": "Data source has been updated.",
        "Źródło zostało usunięte.": "Source has been deleted.",
        "Zwrócony": "Returned"
    }
};
